export default __webpack_public_path__ + "static/media/m-desc-main-banner.2833a03b.svg";